'use client';
import { FC } from 'react';
import ColsWithForm from '@egalite/ui/IncluiPCD/RegisterCompany/ColsWithForm';
import Typography from '@egalite/ui/Typography';
// import DefaultButton from '@egalite/ui/Buttons/GeneralButtons/DefaultButton';
import { SecondaryButton } from '@egalite/ui/Buttons/GeneralButtons';
import FormCard from '@egalite/ui/IncluiPCD/RegisterCompany/FormCard';
import FormRegisterCompany from './FormRegisterCompany';
import Link from 'next/link';

const Hero: FC = () => {
	return (
		<ColsWithForm
			col1={
				<>
					<Typography variant="headline-1">
						Encontre os melhores profissionais com deficiência e reforce sua marca empregadora
					</Typography>
					<Typography variant="body-1">
					Inauguramos um novo capítulo na IncluiPcD, transformando a celebração anual de inclusão numa prática diária com nossa plataforma inovadora. 
					Não é mais preciso esperar até setembro, lançamos a nossa plataforma contínua de conexão entre empresas comprometidas com a inclusão e profissionais com deficiência talentosos e qualificados. 
					Transforme sua empresa com a inclusão todos os dias.
					</Typography>
					<Link href="/cadastroempresa/#beneficios">
						<SecondaryButton>Conheça os benefícios exclusivos</SecondaryButton>
					</Link>
				</>
			}
			col2={
				<FormCard id="cadastro">
					<FormRegisterCompany />
				</FormCard>
			}
		/>
	);
};

export default Hero;
